module.exports = __webpack_public_path__ + "2a051e8f38307d198ddc5a2b0605c113.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-4/sephora.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-4/sephora.jpg
// module chunks = 40